import * as api from '../api';
import { Model } from '../common';
@Model('BugReport')
export class BugReport extends api.ApiBugReport {
    static ROOT_URL = '/engineering/bugs';
    static API = api.BugsApi;

    static report(title : string, details : string, logs : string[], localStorage?: any): Promise<BugReport> {
        return BugReport.inject(api.BugsApi)
            .report({
                title,
                logs: logs.join("\n"),
                agent: navigator.userAgent,
                local_storage: localStorage,
                details
            })
            .toPromise()
            .catch(e => {
                throw e.json();
            })
        ;
    }
}